import React from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import "./RightsSeal.css";

const RightsSeal = ({ asset, modules, intl }) => {
  const useRights = (modules || []).some(
    module => module.name === "useRights" && module.activate
  );

  if (!useRights || !asset || asset.unavailable || asset.type === "folder" || asset.type === "bunker") {
    return null;
  }

  // Que un archivo quede fuera del alcance del módulo por su tipo (ofimática,
  // comprimidos, tipografías) es una regla interna: no es algo que el usuario
  // tenga que leer en cada tarjeta. Antes llevaba su propio rótulo gris y sólo
  // ensuciaba la grilla (feedback de Ricardo, 2026-09-10).
  if (asset.isContent === false) {
    return null;
  }

  // Sólo se sella lo que pide atención. `not_required` es una decisión tomada,
  // igual que `valid`: no lleva marca.
  if (asset.rightsState !== "unassigned" && asset.rightsState !== "expired") {
    return null;
  }

  // Burbuja en la esquina superior derecha, no la franja inferior de ancho
  // completo que había antes: esa zona de la tarjeta ya la usa el nombre del
  // archivo, y convivir con ella obligaba a empujar el hover 31px hacia arriba.
  // El texto vive en el title, así que se lee al pasar el mouse sin ocupar
  // lugar de forma permanente.
  const expired = asset.rightsState === "expired";
  const label = intl.formatMessage({
    id: expired ? "rights_grid_expired" : "rights_grid_unassigned"
  });
  return (
    <div
      className={`bk-seal-dot ${expired ? "ex" : "un"}`}
      title={label}
      role="img"
      aria-label={label}
    >
      <span aria-hidden="true">⚠</span>
    </div>
  );
};

const RightsUnavailableBase = ({ intl }) => (
  <div className="bk-rights-unavailable" role="status">
    <span className="bk-rights-unavailable__icon" aria-hidden="true">⃠</span>
    <span>
      <strong>{intl.formatMessage({ id: "rights_grid_unavailable_title" })}</strong>
      <small>{intl.formatMessage({ id: "rights_grid_unavailable_description" })}</small>
    </span>
  </div>
);

export const RightsUnavailable = injectIntl(RightsUnavailableBase);

const mapStateToProps = state => ({
  modules: state.client.data ? state.client.data.modules : []
});

export default injectIntl(connect(mapStateToProps)(RightsSeal));
